<app-sidenav>
  <h2 class="page-title pt-2 pl-5 mt-4">Meu Perfil</h2>
    <div class="row d-flex justify-content-center">
      <div class="box-form col-lg-6 col-md-12 col-sm-12 mt-3 p-5">
        <form [formGroup]="formUpdateUsuario">
          <h3 class="form-title">Dados do Usuário</h3>
          <div class="form-row mt-5">
            <div class="form-group col-md-5">
              <label class="form-label">CPF</label>
              <input type="text" mask="000.000.000-00" formControlName="documentoIdentificador" class="form-control">
            </div>
            <div class="form-group col-md-6">
              <label class="form-label">Nome</label>
              <input type="text" formControlName="nome" class="form-control">
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="form-group col-md-6">
              <label class="form-label">Email</label>
              <input data-testid="altera-email-perfil" type="text" formControlName="email" autocomplete="off" class="form-control">
              <span class="error-form ml-2" *ngIf="email.invalid && (email.dirty || email.touched)">Digite um email válido.</span>
            </div>
            <div class="form-group col-md-6">
              <label class="form-label">Confirme seu Email</label>
              <input data-testid="confirma-email-perfil" autocomplete="off" type="text" formControlName="confirmaEmail" class="form-control">
              <span class="error-form ml-2" *ngIf="confirmaEmail.invalid && (confirmaEmail.dirty || confirmaEmail.touched)">Digite um email válido.</span>
            </div>
            <span class="error-form ml-2" *ngIf="!emailVerified">Email não verificado.</span>
          </div>
          <div class="form-row d-flex-justify-content-start align-items-center">
            <button data-testid="botao-att-dado-user" class="btn mt-5" (click)="updateUsuario()">Atualizar</button>
          </div>
        </form>

        <h2 class="mt-5 form-title text-left" *ngIf="usuario.empresas.length <= 0">Credores Pessoa Jurídica</h2>
        <div class="mt-5" *ngFor="let emp of usuario.empresas; let i = index">
          <div class="form-row align-items-center">
            <div class="col">
              <h2>Credor Pessoa Jurídica {{ i + 1 }} <i data-testid="botao-edit-representante" class="fas fa-edit icon-change" *ngIf="emp.necessaryAdjustment" (click)="updateEmpresa(emp)"></i></h2>
            </div>
          </div>

          <div class="form-row mt-2">
            <div class="col-md-6">
              <label class="form-label">
                Documento Identificador
              </label>
              <input type="text" [(ngModel)]="emp.cnpj" mask="AA.AAA.AAA/AAAA-AA" class="form-control" disabled>
            </div>
            <div class="col-md-6">
              <label class="form-label">
                Nome / Razão Social
              </label>
              <input type="text" [(ngModel)]="emp.nomeEmpresa" class="form-control" disabled>
            </div>
          </div>
        </div>

        <div class="form-row d-flex-justify-content-start align-items-center">
          <button data-testid="botao-cadastra-credor" class="btn mt-5" (click)="cadastrarEmpresa()">{{usuario.empresas.length > 0? "Atualizar" : "Inserir" }}</button>
        </div>
      </div>


      <form class="box-form col-sm-12 col-lg-4 col-md-12 mx-lg-3 mx-sm-0 p-5 mt-3" [formGroup]="formUpdateSenha">
        <h3 class="form-title">Alterar senha</h3>
        <div class="form-row mt-4">
          <div class="form-group col-md-12 mt-3">
            <label class="form-label">Senha atual <b class="text-danger">*</b></label>
            <input data-testid="senha-atual-perfil" autocomplete="off" type="password" formControlName="senhaAntiga" class="form-control">
          </div>
          <div class="form-group col-md-12 mt-1">
            <label class="form-label">Digite a nova senha <b class="text-danger">*</b></label>
            <input data-testid="nova-senha-perfil" autocomplete="off" type="password" class="form-control" formControlName="novaSenha">
          </div>
          <div class="form-group col-md-12 mt-1">
            <label class="form-label">Confirme a nova senha <b class="text-danger">*</b></label>
            <input data-testid="confirma-senha-perfil" autocomplete="off" type="password" class="form-control" formControlName="confirmaSenha">
          </div>
          <div class="form-group col-md-12 mt-5">
            <button data-testid="botao-atualiza-senha" class="btn" (click)="updatePassword()">Atualizar</button>
          </div>
        </div>
      </form>
    </div>
</app-sidenav>
